import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { allFilterPages } from '@features/filter/static/filterUtil';
import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

const Status = ({ filterPageName, isDependentFilter }) => {
	const [options, setOptions] = useState([]);
	const [allOptionList, setAllOptionList] = useState([]);
	const storeData = []; //TODO ( fetch store data for corresponding field)
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);

	useEffect(() => {
		if (!isDependentFilter) {
			setOptions(allOptionList);
		}
	}, [storeData]);

	useEffect(() => {
		if (allOptionList?.length === 0 && !isDependentFilter) {
			//TODO ( dispatch store data for corresponding field)
		} else {
			onSetFieldData();
		}
	}, [dependentFilterList]);

	const filterData = {
		[allFilterPages.COLLECTION_LIST]: dependentFilterList?.filterSubCategoryList,
		[allFilterPages.PRODUCT_LIST]: dependentFilterList?.filterSubCategoryList,
		[allFilterPages.CLIENT_LIST]: dependentFilterList?.statusList,
		[allFilterPages.FAVOURITE_DETAILS]: dependentFilterList?.filterSubCategoryList,
		[allFilterPages.COLLECTION_DETAILS]: dependentFilterList?.filterSubCategoryList
	};

	const onSetFieldData = () => {
		let responseData = isDependentFilter
			? filterData[filterPageName]?.map((item) => ({
					id: item.constant,
					name: item.name,
					count: item.count
				}))
			: storeData?.map((item) => {
					return { id: item.constant, name: item.name };
				});
		setAllOptionList(responseData);
		setOptions(responseData);
	};

	const handleSearch = (e) => {
		let searchResult = e.target.value
			? allOptionList.filter((item) => item.name.toLowerCase().includes(e.target.value.toLowerCase()))
			: allOptionList;
		setOptions(searchResult);
	};

	return (
		<>
			<FilterName type="STATUS" />
			<Checkbox type="STATUS" data={options} handleSearch={handleSearch} />
		</>
	);
};

export default Status;
